import { render, staticRenderFns } from "./roomTemplatePull.vue?vue&type=template&id=0344838b&scoped=true&"
import script from "./roomTemplatePull.vue?vue&type=script&lang=js&"
export * from "./roomTemplatePull.vue?vue&type=script&lang=js&"
import style0 from "./roomTemplatePull.vue?vue&type=style&index=0&id=0344838b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344838b",
  null
  
)

export default component.exports